/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserContext } from '../contexts';

export interface IPostUpdateEmployeeConfigPayload {
  userId: string;
  listRoundingFrequency: string;
}

/**
 * Redux slice for managing user-related state using Redux Toolkit's `createSlice`.
 *
 * This slice handles actions related to user data, roles, facilities, patients, employees, and delegates, including:
 * - Managing user section and UI state
 * - Setting discharge parameters for patients
 *
 * @property {object} initialState - The initial state for the user context.
 * @property {Function} setUserSection - Sets the current user section in the state.
 * @property {Function} clearUserSection - Clears the current user section from the state.
 * @property {Function} setDischargeParams - Sets discharge parameters for patients.
 *
 * @example
 * dispatch(setUserSection('patient'))
 *
 * @returns {object} The user slice reducer and actions.
 */
const userSlice = createSlice({
  name: 'user',
  initialState: UserContext,
  reducers: {
    setUserSection: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        userSection: action.payload
      };
    },
    clearUserSection: state => {
      return {
        ...state,
        userSection: ''
      };
    },
    // TODO: Need to look at all this logic and see if it is still needed
    setDischargeParams: (
      state,
      action: PayloadAction<{ accountNumbers: string[]; facilityId: string }>
    ) => {
      return {
        ...state,
        dischargeParams: action.payload
      };
    }
  }
});

export const { setUserSection, clearUserSection, setDischargeParams } =
  userSlice.actions;

export default userSlice.reducer;
